export class HistoryActionsHub {
}
